import { DefaultService } from '@/services/DefaultService';

export default class MMChaveLiberacaoService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(liberacao) {
        return this._http.post(`${this._env}/mmchaveliberacao/`, liberacao, this._headers)
            .then(res => res.body, this.handleError);
    }

    find(imei,idClienteSovis) {
        return this._http.get(`${this._env}/mmchaveliberacao/${imei}/${idClienteSovis}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

    getData(imei,idAparelho) {
        return this._http.get(`${this._env}/mmchaveliberacao/data/${imei}/${idAparelho}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw err;
        });
    }

}